<button (click)="goToPage(params)" title="Edit" *ngIf="isEditVisible" style="padding-right: 10px">
    <img src="../assets/edit.svg" height="25" width="25" alt="Edit Icon" />
</button>